/* eslint-disable jsx-a11y/anchor-has-content */

import Dropdown from '@helsenorge/designsystem-react/components/Dropdown';
import Globe from '@helsenorge/designsystem-react/components/Icons/Globe';

import { mapCultureNameToLanguageLocale } from '@helsenorge/core-cms/shared/language';
import { setUserLanguage } from '@helsenorge/framework-utils/hn-language';

import styles from './styles.module.scss';

interface LanguageVersion {
  language: string;
  cultureName: string;
  resolvedUrl: string;
  isCurrentLanguage: boolean;
}

export interface LanguageSelectorProps {
  languageVersions: LanguageVersion[];
  triggerText: string;
}

const LanguageSelector: React.FunctionComponent<LanguageSelectorProps> = ({ languageVersions, triggerText }) => {
  const handleLanguageChange = (cultureName: string): void => {
    const locale = mapCultureNameToLanguageLocale(cultureName);
    if (locale) {
      setUserLanguage(locale);
    }
  };

  const ABOVE_TOC_Z_INDEX = 81000;

  return (
    <div className={styles.languageselector}>
      <Dropdown
        svgIcon={Globe}
        triggerText={triggerText}
        variant="borderless"
        noCloseButton
        dropdownMinWidth={300}
        zIndex={ABOVE_TOC_Z_INDEX}
      >
        {languageVersions.map(language => (
          <Dropdown.SingleSelectItem
            key={language.cultureName}
            text={language.language}
            asChild
            defaultSelected={language.isCurrentLanguage}
          >
            <a href={language.resolvedUrl} onClick={() => handleLanguageChange(language.cultureName)} />{' '}
          </Dropdown.SingleSelectItem>
        ))}
      </Dropdown>
    </div>
  );
};

export default LanguageSelector;
